import { useNavigate } from '@tanstack/react-router';
import { Modal, useToast } from '@/primer/components';
import { useOptOutCampaign } from '@/api';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  campaignId: number;
}

/** Confirmation modal for opting out of a campaign. Navigates to /dashboard on success. */
export function OptOutConfirmationModal({ isOpen, onClose, campaignId }: Props) {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const optOutMutation = useOptOutCampaign();

  const handleConfirm = () => {
    optOutMutation.mutate(campaignId, {
      onSuccess: () => {
        onClose();
        navigate({ to: '/dashboard' });
      },
      onError: () => {
        showToast({ variant: 'error', message: 'Failed to opt out. Please try again.' });
      },
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      icon="circle-info-filled"
      title="Decline this partnership?"
      description="If you decline, this invitation will be removed and you won't receive this product. This action can't be undone."
      primaryButton={{
        label: 'Opt out',
        onClick: handleConfirm,
        disabled: optOutMutation.isPending,
        isLoading: optOutMutation.isPending,
      }}
      secondaryButton={{
        label: 'Cancel',
        onClick: onClose,
        disabled: optOutMutation.isPending,
      }}
    />
  );
}

export default OptOutConfirmationModal;
